import React, { useMemo, useState } from "react";
import PurchaseConfirmation from "./purchase_confirmation";
import coin from "../../assets/img/icons/coin.avif";
import coupon_fallback_img from "/src/assets/img/coupon_fallback.jpg"
const MyorderCards = ({ couponData = [], loading = false }) => {
    const [selectedCouponData, setSelectedCouponData] = useState(null);

    const orders = useMemo(() => (Array.isArray(couponData) ? couponData : []), [couponData]);

    function openOrderDetails(data) {
        const voucherCodes = data?.gift_card_voucher?.map((item) => item.voucherCode).join(",");
        const voucherPin = data?.gift_card_voucher?.map((item) => item.pin).join(",");

        setSelectedCouponData({
            couponData: data,
            voucher_code: voucherCodes || data?.voucher_code || "",
            voucher_pin: voucherPin || ""
        });
    }

    return (
        <section className="my-orders-section pd-top-120">
            <style>
                {`
                .my-orders-section {
                    position: relative;
                }
                .my-orders-shell {
                   
                                background: radial-gradient(circle at top right, rgb(0 0 0), transparent 55%), linear-gradient(180deg, #121212 0%, #101010 100%);
                    border: 1px solid #2b2b2b;
                    border-radius: 16px;
                    padding: 20px;
                }
                .my-order-card {
                    background: linear-gradient(145deg, #1a1a1a, #131313);
                    border: 1px solid #323232;
                    border-radius: 14px;
                    padding: 16px;
                    margin-bottom: 14px;
                    transition: transform 0.22s ease, border-color 0.22s ease, box-shadow 0.22s ease;
                }
                .my-order-card:hover {
                    transform: translateY(-2px);
                    border-color: #ff810e66;
                    box-shadow: 0 10px 24px rgba(0, 0, 0, 0.35);
                }
                .my-order-img {
                    width: 168px;
                    border-radius: 10px;
                    object-fit: cover;
                    border: 1px solid #2f2f2f;
                }
                .my-order-title {
                    margin: 0;
                    color: #ffffff;
                    font-size: 20px;
                    font-weight: 700;
                    line-height: 1.3;
                }
                .my-order-meta {
                    color: #b8b8b8;
                    font-size: 13px;
                }
                .my-order-chip {
                    display: inline-flex;
                    align-items: center;
                    background: #0f0f0f;
                    border: 1px solid #2f2f2f;
                    border-radius: 999px;
                    padding: 6px 12px;
                    font-size: 13px;
                    color: #d9d9d9;
                    gap: 6px;
                }
                .my-order-status {
                    display: inline-flex;
                    align-items: center;
                    padding: 4px 10px;
                    border-radius: 999px;
                    font-size: 12px;
                    text-transform: capitalize;
                    border: 1px solid #ff810e55;
                    color: #ffb165;
                    background: rgba(255, 129, 14, 0.12);
                }
                .my-order-link {
                    color: #ffb165;
                    text-decoration: underline;
                    cursor: pointer;
                    font-weight: 600;
                }
                .my-order-empty {
                    text-align: center;
                    color: #c7c7c7;
                    padding: 40px 12px;
                }
                @media (max-width: 767px) {
                    .my-order-img {
                        width: 100%;
                        max-width: 100%;
                        margin-bottom: 14px;
                    }
                    .my-order-title {
                        font-size: 18px;
                    }
                }
                `}
            </style>

           <div className="container-md">
            <div className="row">
            <div className="col-lg-2 col-md-2 col-12"></div>
            <div className="col-lg-8 col-md-8 col-12">
                <div className="row justify-content-center">
                    <div className="col-lg-6">
                        <div className="section-title text-center">
                            <h2 className="title move-line-3d">Your Orders</h2>
                            {/* <img className="mt-3" src="./assets/img/icon/shalep-1.avif" alt="img" /> */}
                        </div>
                    </div>
                </div>

                <div className="my-orders-shell">
                    {loading ? (
                        <div className="my-order-empty">Loading your orders...</div>
                    ) : null}

                    {!loading && orders.length === 0 ? (
                        <div className="my-order-empty">Play well, place your orders.</div>
                    ) : null}

                    {!loading && orders.length > 0
                        ? orders.map((data, index) => (
                            <article className="my-order-card" key={`${data?.order_id || "order"}-${index}`}>
                                <div className="row g-3 align-items-center">
                                    <div className="col-md-3 col-12">
                                        <img
                                            src={data?.thumb_img || coupon_fallback_img}
                                            onError={(e) => {
                                                e.currentTarget.onerror = null;
                                                e.currentTarget.src = coupon_fallback_img;
                                            }}
                                            alt="Coupon Banner"
                                            className="my-order-img"
                                        />
                                    </div>
                                    <div className="col-md-9 col-12">
                                        <div className="d-flex justify-content-between align-items-start flex-wrap gap-2">
                                            <h5 className="my-order-title">{data?.name}</h5>
                                            <span className="my-order-meta">
                                                Ordered: {new Date(data?.crd_on).toLocaleDateString("hi-IN")}
                                            </span>
                                        </div>

                                        <div className="d-flex flex-wrap gap-2 mt-3">
                                            <span className="my-order-chip">Expires: {data?.expiryAndValidity || "N/A"}</span>
                                            <span className="my-order-chip">
                                                Spent:
                                                <img src={coin} style={{ width: "14px", height: "18px", paddingBottom: "2px" }} alt="" />
                                                {Math.round(Number(data?.price || 0))}
                                            </span>
                                            <span className="my-order-status">{data?.purchase_stat || "pending"}</span>
                                        </div>

                                        <div className="d-flex justify-content-between align-items-center mt-4 flex-wrap gap-2">
                                            <span className="my-order-meta">
                                                Order ID: <span style={{ color: "#ff810e", fontWeight: 700 }}>{data?.order_id}</span>
                                            </span>
                                            <button
                                                type="button"
                                                className="my-order-link"
                                                onClick={() => openOrderDetails(data)}
                                                style={{ background: "transparent", border: 0 }}
                                            >
                                                View details
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </article>
                        ))
                        : null}
                </div>
            </div>
            </div>
            </div>
            {selectedCouponData ? (
                <PurchaseConfirmation
                    couponData={{
                        couponData: selectedCouponData.couponData,
                        voucher_code: selectedCouponData.voucher_code,
                        voucher_pin: selectedCouponData.voucher_pin
                    }}
                    onClose={() => setSelectedCouponData(null)}
                />
            ) : null}
        </section>
    );
};

export default MyorderCards;
